// extracted by mini-css-extract-plugin
export default {"inputClassname":"QuantityInput_inputClassname__mQRUX"};